/*
 * @Author: wushenghe 2365247152@qq.com
 * @Date: 2024-07-14 13:49:43
 * @LastEditors: wushenghe 2365247152@qq.com
 * @LastEditTime: 2024-07-14 15:13:42
 * @FilePath: \huijiao-portal\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: '/',
    name: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/HomeView'),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
